import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import Config from '../../Core/Config.js';
import { framework } from 'saffroncodejs';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import UserManager from '../../Core/UserManager';
import { libs, ui } from 'saffroncodejs';
var PageManager = framework.PageManager;

class Badane extends React.Component {
    constructor(props) {
        super(props);
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);
        this.state = {
            isloading: true,
            activeTab: 1,
            data: { "BId": 379089, "Reshte": 4, "PishnahadId": 311366, "PishnahadDate": "1392/11/09", "FullBNo": "92/28/99/99/3522964", "BNSodurDate": "1392/11/09", "Agent": "اجرايي مرکز کد 99", "BimeGozar": "روزيتا حقيقي کد 2040420", "CodeMelli": "0062878115", "BimeGozarTel": "44128571", "BimeGozarAddress": "ميرداماد ميدان مادر خيابان بهروز پ 11", "KhodroText": "هيونداي ورنا", "ZarfiatText": "ظرفيت مجاز", "SalSakht": 1384, "PelakKindText": "شخصي", "PelakNo": "468ص96", "PelakText": "468ص96 ايران 11", "ShasiNo": "IR843311003817", "MotorNo": "G4EB4664344", "ColorText": "سفيد روغني", "YadakColorText": null, "SilandrCount": 4, "Otagh": null, "Moddat": 365, "BeginDate": "1392/11/10", "EndDate": "1393/11/10", "MainKhatarText": "آتش سوزي ، صاعقه ، انفجار ، حادثه ، سرقت کلي", "PusheshEzafiText": "شكست شيشه به تنهايي-مواد شيميايي-اياب و ذهاب-سرقت در جاي تمام قطعات(20% ارزش مورد بيمه )", "SabegheAsliText": "پنجم   ", "SabegheEzafiText": "پنجم   ", "HasSabegheAsli": "دارد", "HasSabegheEzafi": "دارد", "SalAdamKhesarat": 5, "salAdamKhesaratEzafi": 5, "HBwithmaliat": 589688, "ShahrdariAvarez": 13351, "AfzoodehMaliat": 20027, "HBTakhfif": 5624930, "HBTotal": 6181240, "ExtraEquipment": [{ "Id": 273435, "BId": 379089, "ElhNo": 1, "ToElhNo": null, "VasileKind": "كليه قطعات فابريك", "VasileSharh": "كليه قطعات فابريك", "Sarmaye": 46000000, "SerghatSarmaye": 46000000, "VasileCount": 1, "IsValid": 160 }], "Capital": [{ "BId": 379089, "ArzeshMoredBime": 230000000, "YadakArzesh": 0 }], "SpecialCondition": [{ "Id": 1285366, "BId": 379089, "ElhNo": 0, "Shart": "قسمت متحرك راديو پخش فاقد پوشش سرقت درجا مي باشدو در صورت سرقت دستگاه ثابت پرداخت خسارت منوط به تحويل قسمت متحرك به بيمه گر خواهد بود.", "Sharh": null, "ToElhNo": null, "FinalElhNo": 0 }, { "Id": 1285367, "BId": 379089, "ElhNo": 0, "Shart": "در صورت پرداخت خسارت کلي و تحويل لاشه بعنوان بازيافتي و همچنين سرقت کلي مورد بيمه انتقال سند مالکيت وسيله نقليه به بيمه گر الزامي است.", "Sharh": null, "ToElhNo": null, "FinalElhNo": 0 }, { "Id": 1285368, "BId": 379089, "ElhNo": 0, "Shart": "اين بيمه نامه با تخفيف کارمندي صادر گرديده و غير قابل انتقال به ديگري ميباشد.", "Sharh": null, "ToElhNo": null, "FinalElhNo": 0 }, { "Id": 1285369, "BId": 379089, "ElhNo": 0, "Shart": "حق بيمه فوق بصورت نقدي دريافت گرديد.", "Sharh": null, "ToElhNo": null, "FinalElhNo": 0 }, { "Id": 1285370, "BId": 379089, "ElhNo": 0, "Shart": "بيمه نامه شماره فوق داراي مواضع آسيب ديده ميباشد .", "Sharh": "بيمه نامه شماره فوق داراي مواضع آسيب ديده ميباشد .", "ToElhNo": null, "FinalElhNo": 0 }, { "Id": 1285371, "BId": 379089, "ElhNo": 0, "Shart": "بيمه گذار محترم توجه داشته باشيد : پس از اخذ خسارت خودرو و تعمير و مرمت آن بازديد پس از تعمير (سلامت) توسط کارشناس بيمه گر الزامي ميباشد. در غير اين صورت به هنگام خسارت مجدد مواضع آسيب ديده قبلي ، قابل پرداخت نخواهد بود .", "Sharh": null, "ToElhNo": null, "FinalElhNo": 0 }, { "Id": 1285372, "BId": 379089, "ElhNo": 0, "Shart": "بيمه گذار محترم جهت ارزيابي خسارت لطفا\" با شماره تلفن 84325-021  تماس حاصل فرمائيد .", "Sharh": "بيمه گذار محترم جهت دريافت خسارت لطفا\" با شماره تلفن 84325-021  تماس حاصل فرمائيد .", "ToElhNo": null, "FinalElhNo": 0 }], "Bill": [{ "RsdId": 28193787, "RsdDate": "1392/11/09", "RcvdKind": 28, "RcvdkindTitle": "صندوق", "TasvieDAmount": 589688, "BADisplayName": null, "RcvdNo": "28193789", "RcvdDate": "1392/11/09", "MoneyUnit": 1, "BId": 379089, "ElhNo": 0 }], "Endorsement": [], "LastBnoText": "1120/410510/91/004442 ", "LastBNoDate": "1392/11/10", "LastBimeCompanyText": "پارسيان", "MoredestefadeText": "شخصي", "ErrorMessage": null }
        }
        this.state.data = {};

        this.state.btns = [];

        this.loadDetail();

    }

    encodeSodurId(encodedId) {
        return encodedId;
    }

    componentWillReceiveProps(props) {
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);

        this.loadDetail();
    }

    loadDetail() {
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/Cr/api/Badane/PolicyInfo",

                { id: this.currentSodurId, codeMelli: UserManager.MelliCode() }
            ),
            BimeManager.header())
            .then((result) => {
                console.log("result.data : ", JSON.stringify(result.data));
                this.setState({ data: result.data, isloading: false })
            })
            .catch((error) => { alert(error) })
    }
    pagechange(bid,reshte) {

        PageManager.changePage(Config.p_pardakhtman, [bid,reshte]);
    }

    render() {
        return (
            <div>
                <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>بیمه نامه بدنه</h4>
                    </Col>
                </Row>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 1 }}
                            onClick={() => { this.setState({ activeTab: 1 }) }}>
                            جزئیات
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 2 }}
                            onClick={() => { this.setState({ activeTab: 2 }) }}>
                            الحاقیه
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 3 }}
                            onClick={() => { this.setState({ activeTab: 3 }) }}>
                            لوازم و قطعات
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 4 }}
                            onClick={() => { this.setState({ activeTab: 4 }) }}>
                            سرمایه
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink onClick={() => { this.pagechange(this.currentSodurId,this.state.data.Reshte) }}>
                            پرداخت شده ها
                        </NavLink>
                    </NavItem>

                </Nav>


                {!this.state.isloading ? (



                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId={1}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">
                                        <Row>
                                            <Col sm="12"><span className="bold-head">شماره پیشنهاد:</span>{this.state.data.PishnahadId}</Col>
                                            <Col sm="12"><span className="bold-head">تاریخ پیشنهاد:</span>{this.state.data.PishnahadDate}</Col>
                                            <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{this.state.data.FullBNo}</Col>
                                            <Col sm="12"><span className="bold-head">تاریخ صدور بیمه نامه:</span>{this.state.data.BNSodurDate}</Col>
                                            <Col sm="12"><span className="bold-head">نماینده/کارگزار:</span>{this.state.data.Agent}</Col>
                                            <Col sm="12"><span className="bold-head">بیمه گذار:</span>{this.state.data.BimeGozar}</Col>
                                            <Col sm="12"><span className="bold-head">کد ملی:</span>{this.state.data.CodeMelli}</Col>
                                            <Col sm="12"><span className="bold-head">تلفن:</span>{this.state.data.BimeGozarTel}</Col>
                                            <Col sm="12"><span className="bold-head">نشانی:</span>{this.state.data.BimeGozarAddress}</Col>
                                            <Col sm="12"><span className="bold-head">نوع و سیستم خودرو:</span>{this.state.data.KhodroText}</Col>
                                            <Col sm="12"><span className="bold-head">ظرفیت:</span>{this.state.data.ZarfiatText}</Col>
                                            <Col sm="12"><span className="bold-head">سال ساخت:</span>{this.state.data.SalSakht}</Col>
                                            <Col sm="12"><span className="bold-head">کاربری:</span>{this.state.data.MoredestefadeText}</Col>
                                            <Col sm="12"><span className="bold-head">شماره کامل پلاک:</span>{this.state.data.PelakText}</Col>
                                            <Col sm="12"><span className="bold-head">شماره شاسی:</span>{this.state.data.ShasiNo}</Col>
                                            <Col sm="12"><span className="bold-head">شماره موتور:</span>{this.state.data.MotorNo}</Col>
                                            <Col sm="12"><span className="bold-head">رنگ:</span>{this.state.data.ColorText}</Col>
                                            <Col sm="12"><span className="bold-head">تعداد سیلندر:</span>{this.state.data.SilandrCount}</Col>
                                            <Col sm="12"><span className="bold-head">نوع اتاق:</span>{this.state.data.Otagh}</Col>
                                            <Col sm="12"><span className="bold-head">مدت:</span>{this.state.data.Moddat}</Col>
                                            <Col sm="12"><span className="bold-head">تاریخ شروع:</span>{this.state.data.BeginDate}</Col>
                                            <Col sm="12"><span className="bold-head">تاریخ پایان:</span>{this.state.data.EndDate}</Col>
                                            <Col sm="12"><span className="bold-head">خطرات تحت پوشش:</span>{this.state.data.MainKhatarText}</Col>
                                            <Col sm="12"><span className="bold-head">پوششهاي اضافي شامل:</span>{this.state.data.PusheshEzafiText}</Col>
                                            <Col sm="12"><span className="bold-head">عدم خسارت پوشش هاي اصلي:</span>{this.state.data.HasSabegheAsli}</Col>
                                            <Col sm="12"><span className="bold-head">عدم خسارت پوشش هاي اضافي:</span>{this.state.data.HasSabegheEzafi}</Col>
                                            <Col sm="12"><span className="bold-head">سال عدم خسارت پوشش هاي اصلی:</span>{this.state.data.SalAdamKhesarat}</Col>
                                            <Col sm="12"><span className="bold-head">سال عدم خسارت پوشش هاي اضافی:</span>{this.state.data.salAdamKhesaratEzafi}</Col>
                                            <Col sm="12"><span className="bold-head">حق بیمه قابل پرداخت</span>{libs.StringFunctions.currancyPrint(this.state.data.HBwithmaliat) + ('ریال')}</Col>
                                            <Col sm="12"><span className="bold-head">عوارض شهرداری:</span>{libs.StringFunctions.currancyPrint(this.state.data.ShahrdariAvarez) + ('ریال')}</Col>
                                            <Col sm="12"><span className="bold-head">مالیات:</span>{libs.StringFunctions.currancyPrint(this.state.data.AfzoodehMaliat) + ('ریال')}</Col>
                                            <Col sm="12"><span className="bold-head">جمع تخفیفات:</span>{libs.StringFunctions.currancyPrint(this.state.data.HBTakhfif) + ('ریال')}</Col>
                                            <Col sm="12"><span className="bold-head">حق بیمه:</span>{libs.StringFunctions.currancyPrint(this.state.data.HBTotal) + ('ریال')}</Col>
                                            <Col sm="12"><span className="bold-head">شماره بيمه نامه سال قبل:</span>{this.state.data.LastBnoText}</Col>
                                            <Col sm="12"><span className="bold-head">تاریخ انقضاء بیمه نامه سال قبل:</span>{this.state.data.LastBNoDate}</Col>
                                            <Col sm="12"><span className="bold-head">بیمه نامه سال قبل نزد شرکت:</span>{this.state.data.LastBimeCompanyText}</Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>

                        <TabPane tabId={2}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">
                                        <Row>
                                            {
                                                //alert('bill***'+this.state.data.Bill)
                                                (this.state.data.Endorsement) ? this.state.data.Endorsement.map((endorsement) => {
                                                    return <div className="border-List">
                                                        <Col sm="12"><span className="bold-head">نوع بیمه نامه:</span>{endorsement.Noebimename}</Col>
                                                        <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه:</span>{endorsement.BId}</Col>
                                                        <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{endorsement.FullBNo}</Col>
                                                        <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{endorsement.ElhNo}</Col>
                                                        <Col sm="12"><span className="bold-head">شماره ردیف سالانه:</span>{endorsement.Radif}</Col>
                                                        <Col sm="12"><span className="bold-head">تاریخ صدور:</span>{endorsement.VSodurDate}</Col>
                                                        <Col sm="12"><span className="bold-head">تاریخ اعمال:</span>{endorsement.ActiveDate}</Col>
                                                        <Col sm="12"><span className="bold-head">معرف/کارگزار:</span>{endorsement.AgentCode}</Col>
                                                        <Col sm="12"><span className="bold-head">بیمه گذار:</span>{endorsement.BimeGozartext}</Col>
                                                        <Col sm="12"><span className="bold-head">واحد صدور:</span>{endorsement.CodeSodurText}</Col>
                                                        <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{endorsement.Sharh}</Col>
                                                        <Col sm="12"><span className="bold-head">عوارض شهرداری:</span>{libs.StringFunctions.currancyPrint(endorsement.shahrdariavarez) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">مالیات بر ارزش افزوده:</span>{libs.StringFunctions.currancyPrint(endorsement.AfzoodehMaliat) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">حق بیمه اضافی:</span>{libs.StringFunctions.currancyPrint(endorsement.EzafiPrm) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">حق بیمه برگشتی:</span>{libs.StringFunctions.currancyPrint(endorsement.BargashtiPrm) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">حق بیمه اضافی با مالیات:</span>{libs.StringFunctions.currancyPrint(endorsement.EzafiAfzoodehMaliat) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">حق بیمه برگشتی با مالیات:</span>{libs.StringFunctions.currancyPrint(endorsement.BargashtiPrmWithMaliat) + ('ریال')}</Col>
                                                        <br />
                                                    </div>

                                                }) : ''
                                            }

                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>

                        <TabPane tabId={3}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">
                                        <Row>
                                            {
                                                //alert('bill***'+this.state.data.Bill)
                                                (this.state.data.ExtraEquipment) ? this.state.data.ExtraEquipment.map((lavazem) => {
                                                    return <div className="border-List">
                                                        <Col sm="12"><span className="bold-head">نوع:</span>{lavazem.VasileKind}</Col>
                                                        <Col sm="12"><span className="bold-head">لوزام و قطعات:</span>{lavazem.VasileSharh}</Col>
                                                        <Col sm="12"><span className="bold-head">سرمایه پوشش اصلی:</span>{libs.StringFunctions.currancyPrint(lavazem.Sarmaye) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">سرمایه سرقت درجا:</span>{libs.StringFunctions.currancyPrint(lavazem.SerghatSarmaye) + ('ریال')}</Col>
                                                        <br />
                                                    </div>

                                                }) : ''
                                            }

                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>

                        <TabPane tabId={4}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">
                                        <Row>
                                            {
                                                //alert('bill***'+this.state.data.Bill)
                                                (this.state.data.Capital) ? this.state.data.Capital.map((sarmaye) => {
                                                    return <div className="border-List">
                                                        <Col sm="12"><span className="bold-head">جمع ارزش مورد بیمه</span>{libs.StringFunctions.currancyPrint(sarmaye.ArzeshMoredBime) + ('ریال')}</Col>
                                                        <Col sm="12"><span className="bold-head">ارزش یدک:</span>{libs.StringFunctions.currancyPrint(sarmaye.YadakArzesh) + ('ریال')}</Col>
                                                        <br />
                                                    </div>

                                                }) : ''
                                            }

                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>


                    </TabContent>) : (<ui.Preloader />)



                }
            </div>
        );
    }
}


export default Badane;


// WEBPACK FOOTER //
// ./src/components/ListCollapse/Badane.js